/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyPharmacyListImage,
  PharmacyPharmacyListImageFromJSON,
  PharmacyPharmacyListImageFromJSONTyped,
  PharmacyPharmacyListImageToJSON,
} from "./";

export const PatchPharmacyListImagesResponseTypename = "PatchPharmacyListImagesResponse" as const;

/**
 *
 * @export
 * @interface PatchPharmacyListImagesResponse
 */
export interface PatchPharmacyListImagesResponse {
  /**
   *
   * @type {Array<PharmacyPharmacyListImage>}
   * @memberof PatchPharmacyListImagesResponse
   */
  listImage?: Array<PharmacyPharmacyListImage>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchPharmacyListImagesResponse
   */
  readonly __typename?: string;
}

export function PatchPharmacyListImagesResponseFromJSON(json: any): PatchPharmacyListImagesResponse {
  return PatchPharmacyListImagesResponseFromJSONTyped(json, false);
}

export function PatchPharmacyListImagesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchPharmacyListImagesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchPharmacyListImagesResponseTypename,

    listImage: !exists(json, "list_image")
      ? undefined
      : (json["list_image"] as Array<any>).map(PharmacyPharmacyListImageFromJSON),
  };
}

export function PatchPharmacyListImagesResponseToJSON(object?: PatchPharmacyListImagesResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    list_image:
      value.listImage === undefined ? undefined : (value.listImage as Array<any>).map(PharmacyPharmacyListImageToJSON),
  };
}
